const { Entity } = require('./entity')
const { removeNonQboSupportedChars } = require('./utils')

class Customer extends Entity {
  constructor (quickbooks, query) {
    super(quickbooks, 'Customer')
    this.query = query
  }

  /**
   * @param {string[]} customerIds
   * @param {string} companyCode
   */
  getList (customerIds, companyCode) {
    if (!customerIds || !customerIds.length) {
      return []
    }

    return this.query.send({
      companyCode,
      type: 'Customer',
      where: `Id in (${[...customerIds].map(id => `'${id}'`).join(',')})`,
      maxResults: 500
    })
  }

  /**
   * @param {string} displayName
   * @param {string} companyCode
   */
  async getByDisplayName (displayName, companyCode) {
    if (!displayName) {
      return []
    }

    const parsedDisplayName = removeNonQboSupportedChars(displayName).replace(/'/g, '\\\'')
    const [response] = await this.query.send({
      companyCode,
      type: 'Customer',
      where: `DisplayName = '${parsedDisplayName}'`,
      maxResults: 1
    })
    return response
  }
}

module.exports = {
  Customer
}
